// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"27": "3007f8ad","366": "9154912f","720": "4cc66255","985": "482cb750",}[chunkId] + ".css"
}